/**
 * Forces dark marketing tokens on the homepage only.
 * Does not touch document.documentElement or aivoryems.ui.theme (admin console unchanged).
 */
export default function LandingDarkScope({ children }) {
  return <div className="aivory-landing min-h-screen text-[var(--text-primary)]">{children}</div>;
}
